import Excel from "exceljs"
import { Translate } from "../../../../../../../../../../constant/Translate"

const {
  EXPORT_EP0054, // 氏名（日）              Full name(Japanese)
  EXPORT_EP0052, // 氏名（英）              Full name(English)
  EXPORT_EP0158, // 人材種別（詳細）         Dispatch type (Detail)
  EXPORT_EP0184, // 所属先名                Group name
  EXPORT_EP0103, // 電話番号                Phone number
  EXPORT_EP0015, // メールアドレス           Email
  EXPORT_EP0049, // 国名・任地・勤務地       Country name/place of employment/place of work
  EXPORT_EP0043, // 現在地                  Current location
  EXPORT_EP0106, // 渡航目的                Purpose of travel
  EXPORT_EP0020, // 案件名                  Project name
  EXPORT_EP0209, // 派遣期間/契約期間        Dispatch duration/Contract duration
  EXPORT_EP0035, // 拠点担当者名             Name of person in charge of overseas office
  EXPORT_EP0128, // 備考1                   Remarks 1
  EXPORT_EP0238, // 出発日                  Departure date
  EXPORT_EP0239, // 出発時間                Departure time
  EXPORT_EP0071, // 出発国                  Country of departure
  EXPORT_EP0154, // 出発都市                City of departure
  EXPORT_EP0240, // 到着日                  Arrival date
  EXPORT_EP0241, // 到着時間                Arrival time
  EXPORT_EP0109, // 到着国                  Country of destination
  EXPORT_EP0155, // 到着都市                City of destination
  EXPORT_EP0011, // チェックイン            Check in
  EXPORT_EP0010, // チェックアウト          Check out
  EXPORT_EP0065, // 宿泊先名称              Accommodation name
  EXPORT_EP0063, // 宿泊先住所、部屋番号等   Accommodation address、room number、etc
  EXPORT_EP0227, // 宿泊先電話番号          Accommodation phone number
  EXPORT_EP0228, // 滞在地携帯番号1         Mobile number 1 at place of destination
  EXPORT_EP0229, // 滞在地携帯番号2         Mobile number 2 at place of destination
  EXPORT_EP0022, // 衛星携帯番号            Satellite mobile number
  EXPORT_EP0101, // 電子メールアドレス1     Email address 1
  EXPORT_EP0102, // 電子メールアドレス2     Email address 2
} = Translate

export const columnsConfig = (worksheet: Excel.Worksheet) => {
  worksheet.columns = [
    { header: EXPORT_EP0054, key: "fullNameKanji", width: 30 }, // width = 22 * 8 = 176px
    { header: EXPORT_EP0052, key: "fullNameRomaji", width: 31 },
    { header: EXPORT_EP0158, key: "dispatchTypeDetailName", width: 32 },
    { header: EXPORT_EP0184, key: "groupName", width: 20 },
    { header: EXPORT_EP0103, key: "phoneNumber", width: 19 },
    { header: EXPORT_EP0015, key: "personEmailAddress", width: 19 },
    {
      header: EXPORT_EP0049,
      key: "workPlaceCountryAndWorkPlaceCity",
      width: 30,
    },
    { header: EXPORT_EP0043, key: "travelerLocation", width: 31 },
    { header: EXPORT_EP0106, key: "travelPurposeName", width: 25 },
    { header: EXPORT_EP0020, key: "projectNameJpOrProjectNameEn", width: 46 },
    {
      header: EXPORT_EP0209,
      key: "departureDateTimeAndArrivalDateTime",
      width: 30,
    },
    { header: EXPORT_EP0035, key: "locationPersonName", width: 26 },
    { header: EXPORT_EP0128, key: "othersRemarks1", width: 25 },
    { header: EXPORT_EP0238, key: "departureDate", width: 30 },
    { header: EXPORT_EP0239, key: "departureTime", width: 30 },
    { header: EXPORT_EP0071, key: "departureCountryName", width: 35 },
    { header: EXPORT_EP0154, key: "departureCityName", width: 35 },
    { header: EXPORT_EP0240, key: "arrivalDate", width: 30 },
    { header: EXPORT_EP0241, key: "arrivalTime", width: 30 },
    { header: EXPORT_EP0109, key: "arrivalCountryName", width: 35 },
    { header: EXPORT_EP0155, key: "arrivalCityName", width: 35 },
    { header: EXPORT_EP0011, key: "lodgingCheckin", width: 30 },
    { header: EXPORT_EP0010, key: "lodgingCheckout", width: 30 },
    { header: EXPORT_EP0065, key: "lodgingName", width: 35 },
    { header: EXPORT_EP0063, key: "lodgingAddress", width: 35 },
    { header: EXPORT_EP0227, key: "lodgingPhoneNumber", width: 35 },
    { header: EXPORT_EP0228, key: "locationPhoneNumber1", width: 35 },
    { header: EXPORT_EP0229, key: "locationPhoneNumber2", width: 35 },
    { header: EXPORT_EP0022, key: "satellitePhoneNumber", width: 35 },
    { header: EXPORT_EP0101, key: "emailAddress1", width: 30 },
    { header: EXPORT_EP0102, key: "emailAddress2", width: 30 },
  ]
}
